import { render } from "./HolidayCategories.vue?vue&type=template&id=4825302e&scoped=true"
import script from "./HolidayCategories.vue?vue&type=script&lang=js"
export * from "./HolidayCategories.vue?vue&type=script&lang=js"

import "./HolidayCategories.vue?vue&type=style&index=0&id=4825302e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4825302e"]])

export default __exports__